import { Box } from "@mui/material";
import React from "react";
import "../../styles/button-switcher.scss";

interface ButtonSwitherType {
  buttonsName: any;
  selectedPlan: any;
  setSelectedPlan: any;
  className: any;
}
const ButtonSwitcher = ({
  buttonsName,
  selectedPlan,
  setSelectedPlan,
  className,
}: ButtonSwitherType) => {
  // Helper function to convert button display names to internal values
  const getInternalValue = (buttonName: string): string => {
    const valueMap: Record<string, string> = {
      // Issue List buttons
      Execution: "execution",
      Validation: "validation",
      "Rule Research": "ruleResearch",
      "Generic Research": "genericResearch",
      // Variable buttons - these need special handling
      "Used Variables": "usedvariables",
      "Unused Variables": "unusedvariables",
      // Legacy support
      Comparison: "comparison",
      Generic: "generic",
    };

    // Return mapped value or fallback to lowercase
    return valueMap[buttonName] || buttonName.replace(" ", "").toLowerCase();
  };

  // Helper function to check if selectedPlan matches the button
  const isSelected = (buttonName: string, selectedPlan: any): boolean => {
    const internalValue = getInternalValue(buttonName);

    // Direct match with internal value
    if (selectedPlan === internalValue) {
      return true;
    }

    // Match with display value (for backward compatibility)
    if (selectedPlan === buttonName) {
      return true;
    }

    return false;
  };

  const handleChange = (event: any) => {
    const buttonName = event.target.getAttribute("data-button-name");
    const internalValue = getInternalValue(buttonName);
    setSelectedPlan(internalValue);
  };
  return (
    <Box className={`switches-container ${className}`}>
      {buttonsName.map((item: any, index: number) => {
        const internalValue = getInternalValue(item);
        const inputId = `${item.replace(" ", "").toLowerCase()}_${index}`;
        return (
          <React.Fragment key={inputId}>
            <input
              type="radio"
              id={inputId}
              name="switchPlan"
              value={internalValue}
              data-button-name={item}
              checked={isSelected(item, selectedPlan)}
              onChange={handleChange}
            />
            <label htmlFor={inputId}>{item}</label>
          </React.Fragment>
        );
      })}
      <Box className="switch-wrapper">
        <Box className="switch">
          {buttonsName.map((item: any, index: number) => {
            return (
              <Box
                key={`switch_${index}`}
                className={isSelected(item, selectedPlan) ? "selected" : ""}
              >
                {item}
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default ButtonSwitcher;
